import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import { RecordLabelState } from '../../../store/record-labels/state';
import { RecordLabelRelation } from '@services/record-labels/types/record-label-relation';
import { UpdateRecordLabelName } from '@webapp/store/record-labels/action-creators';
import {
  DeleteRecordLabel,
  RemoveFromRecordLabel,
  UpdateRelationSplit,
} from '../../../store/record-labels/action-creators';

import styled from 'styled-components';

import LoadingCtrl from '@webapp/controllers/loading';
import EditableCollapsableBox from '@webapp/controllers/editable-collapsable-box';

import { SubscriptionState } from '../../../store/subscription/state';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import LabelRow from './label-row';
import { ListReleasesArtist } from '@webapp/store/release/action-creators';
import { LIST_RELEASES_ARTIST } from '@webapp/store/release/actions';

interface LabelBoxProps {
  className?: string;
  label: RecordLabelRelation;
  relations: RecordLabelState['artists'];
  artistLabels: RecordLabelRelation[];
  subscriptions: SubscriptionState['label'];
  isLoadingList: boolean;
  isExternal: boolean;
  updateRecordLabelName: (
    labelId: string,
    name: string
  ) => UpdateRecordLabelName;
  removeRecordLabel: (labelId: string) => DeleteRecordLabel;
  removeArtist: (relation: RecordLabelRelation) => RemoveFromRecordLabel;
  updateRelationSplit: (
    relation: RecordLabelRelation,
    split: number
  ) => UpdateRelationSplit;
  gotoDeleteLabel: () => CallHistoryMethodAction;
  ListReleasesArtist: (artistId: string) => ListReleasesArtist;
  releases: any[];
}

const mapStateToProps = (state: AppState) => {
  return {
    releases: state.release.listArtist,
    relations: state.recordLabels.artists,
    artistLabels: state.recordLabels.member,
    operators: state.recordLabels.operators,
    subscriptions: state.subscription.label,
    isLoadingList: !!state.ui.loading[LIST_RELEASES_ARTIST],
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateRecordLabelName: (labelId: string, name: string) =>
    dispatch(new UpdateRecordLabelName(labelId, name)),
  removeRecordLabel: (labelId: string) =>
    dispatch(new DeleteRecordLabel(labelId)),
  removeArtist: (relation: RecordLabelRelation) =>
    dispatch(new RemoveFromRecordLabel(relation)),
  updateRelationSplit: (relation: RecordLabelRelation, split: number) =>
    dispatch(new UpdateRelationSplit(relation, split)),
  gotoDeleteLabel: () => dispatch(push('/plans-record-label')),
  ListReleasesArtist: (artistId: string) =>
    dispatch(new ListReleasesArtist(artistId)),
});

export const LabelBox: React.FC<LabelBoxProps> = (props) => {
  const { releases } = props;
  const [relsesesArray, setReleasesArray] = React.useState<any>([]);
  const getArtistsReleases = () => {
    return relsesesArray[props.label.artistId] || [];
  };

  React.useEffect(() => {
    setReleasesArray(releases);
  }, [releases]);

  return (
    <EditableCollapsableBox
      key={props.label.artistId}
      className={props.className}
      value={props.label.artistName}
      placeholder="Label Name"
      text={
        <>
          {`${props.label.artistReleases || 0}`} <Translate id="LABEL.ROSTER" />
        </>
      }
      isOpened={false}
      onClose={
        props.isExternal
          ? undefined
          : () => props.removeRecordLabel(props.label.id)
      }
      onToggle={(isOpened) => {
        if (isOpened && !props.isExternal) {
          props.ListReleasesArtist(props.label.artistId);
          setReleasesArray([]);
        }
      }}
    >
      {props.isLoadingList ? (
        <div className="loader-container">
          <LoadingCtrl
            size="100px"
            className="loading-animation"
            loading={props.isLoadingList}
          />
        </div>
      ) : (
        <>
          {getArtistsReleases()?.map((val: any, idx: any) => (
            <LabelRow
              key={idx}
              title={val.title}
              type={val.type}
              streams={val.streams}
              earned={val.earnings}
              avatar={val.cover.url}
            />
          ))}
        </>
      )}
    </EditableCollapsableBox>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(LabelBox)`
  margin-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    margin-bottom: 30px;
  }
  &:last-child {
    margin-bottom: 0;
  }
`);
